import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';
import FormField  from '../components/FormField';
import Button     from '../components/Button';
import Alert      from '../components/Alert';

export default function Login() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const location     = useLocation();
  const [form, setForm]     = useState({ login: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.login, form.password);
      navigate(location.state?.from || '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to your account">
      <form onSubmit={submit}>
        {error && <Alert>{error}</Alert>}
        <FormField label="Username or Email" name="login" value={form.login} onChange={handle} autoComplete="username" required />
        <FormField label="Password" name="password" type="password" value={form.password} onChange={handle} autoComplete="current-password" required />
        <Button loading={loading} type="submit" style={{ marginTop: '8px' }}>Sign in</Button>
      </form>
      <div style={{ marginTop: '24px', fontSize: '13px', color: 'var(--text-muted)', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Link to="/reset-password" style={{ color: 'var(--accent)', textDecoration: 'none' }}>Forgot password?</Link>
        <span>No account? <Link to="/register" style={{ color: 'var(--accent)', textDecoration: 'none' }}>Register</Link></span>
      </div>
    </AuthLayout>
  );
}
